// eslint-disable-next-line import/prefer-default-export
export const transformPostCode = (value: string): string =>
  value.toUpperCase().replace(/[^A-Z0-9 ]/g, '');
